import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { OrderTransactState, OrderSettlementState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOrderPaymentStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
  settleState: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Order')



const statusLabel = computed(() => {
  switch (props.settleState) {
    // case OrderSettlementState.OSS_ABNORMAL_BIZ_NON_FINISH_STATE: // 业务不是处于完成状态，无法结算
    case OrderSettlementState.OSS_INIT: // 准备结算
      return tl('settleStateInit')
    case OrderSettlementState.OSS_PROCESS: // 结算中
      return tl('settleStateProcess')
    case OrderSettlementState.OSS_ABNORMAL: // 结算未知异常
      return tl('settleStateAbnormal')
    case OrderSettlementState.OSS_ABNORMAL_EXCESS: // 结算异常状态，充超额了
      return tl('settleStateAbnormalExcess')
    case OrderSettlementState.OSS_ABNORMAL_BIZ_NON_FINISH_STATE: // 结算异常状态，充超额了
      return tl('settleStateAbnormalBizNonFinishState')
    case OrderSettlementState.OSS_ABNORMAL_WALLET_LACK_MONEY: // 钱包余额不足
      return tl('settleStateAbnormalWalletLackMoney')
    case OrderSettlementState.OSS_SUCCESS: // 结算完成
      return tl('settleStateSuccess')
  }

  switch (props.state) {
    case OrderTransactState.OTS_INIT: // 初始化状态(改成1,避免0值问题)
      return tl('payStateInit')
    case OrderTransactState.OTS_PAY_PENDING: // 待支付
      return tl('payStatePayPending')
    case OrderTransactState.OTS_PAY_PROCESSING: // 支付中
      return tl('payStatePayProcessing')
    case OrderTransactState.OTS_PAY_SUCCESS: // 支付成功
      return tl('payStatePaySuccess')
    case OrderTransactState.OTS_PAY_FAIL: // 支付失败
      return tl('payStatePayFail')
    case OrderTransactState.OTS_REFUND_INIT: // 待退款
      return tl('payStateRefundInit')
    case OrderTransactState.OTS_REFUNDING: // 退款中
      return tl('payStateRefunding')
    case OrderTransactState.OTS_REBATES: // 部分退款
      return tl('payStateRebates')
    case OrderTransactState.OTS_REFUNDED: // 全额退款
      return tl('payStateRefunded')
    case OrderTransactState.OTS_CLOSE: // 订单关闭, 订单异常，不产生订单金额
      return tl('payStateClose')
  }
  return tl('waitingSettlement')
})

const statusTips = computed(() => {
  switch (props.state) {
    case OrderTransactState.OTS_INIT: // 初始化状态(改成1,避免0值问题)
      return tl('payStateInit')
    case OrderTransactState.OTS_PAY_PENDING: // 待支付
      return tl('payStatePayPending')
    case OrderTransactState.OTS_PAY_PROCESSING: // 支付中
      return tl('payStatePayProcessing')
    case OrderTransactState.OTS_PAY_SUCCESS: // 支付成功
      return tl('payStatePaySuccess')
    case OrderTransactState.OTS_PAY_FAIL: // 支付失败
      return tl('payStatePayFail')
    case OrderTransactState.OTS_REFUND_INIT: // 待退款
      return tl('payStateRefundInit')
    case OrderTransactState.OTS_REFUNDING: // 退款中
      return tl('payStateRefunding')
    case OrderTransactState.OTS_REBATES: // 部分退款
      return tl('payStateRebates')
    case OrderTransactState.OTS_REFUNDED: // 全额退款
      return tl('payStateRefunded')
    case OrderTransactState.OTS_CLOSE: // 订单关闭, 订单异常，不产生订单金额
      return tl('payStateClose')
  }
  return tl('chargeStateProgress')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "top",
    content: _unref(statusTips)
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: "text-status",
        style: _normalizeStyle({ color: _unref(color) })
      }, _toDisplayString(_unref(statusLabel)), 5)
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})